export default __webpack_public_path__ + "images/costco-logo.a4201819f0d3335020a5cdbe9f81a689.png";